import React from 'react';
import './Button.css';

const PrimaryButton = ({
  onClick,
  children,
  size = 'medium',
  disabled = false,
  className = '',
  type = 'button',
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  return (
    <button
      type={type}
      className={`btn btn-primary ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
